import { DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap'
import Icon from '@/components/Icon'
import NotificationsUnreadCount from '@/components/notifications/NotificationsUnreadCount'
import Notifications from '@/components/notifications/Notifications'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from '@/hooks/dispatch'
import { actionCreators } from '@/store/Notifications'

export function NotificationWidget () {
  const [read] = useDispatch([actionCreators.read])
  const [open, setOpen] = useState(false)
  const toggle = useCallback(() => {
    setOpen(o => !o)
  }, [])
  useEffect(() => {
    if (open) {
      read()
    }
  }, [open, read])
  return (
    <Dropdown isOpen={open} toggle={toggle} className='dropdown--notification' >
      <DropdownToggle nav className='nav-link--top'>
        <Icon name='bell' />
        <NotificationsUnreadCount />
      </DropdownToggle>
      <DropdownMenu className='dropdown-menu--last'>
        <div className='d-notification__top'>Notification</div>
        <Notifications menuNotifications className='d-notification__body' onNavigate={toggle} />
      </DropdownMenu>
    </Dropdown>
  )
}



// WEBPACK FOOTER //
// ./src/components/notifications/widget.js